export const environment = {
    api_url: 'https://budget-api.fanbudget.com',
    app_url: 'https://budget-admin.fanbudget.com',
    google_map_api_key: 'AIzaSyC43U2-wqXxYEk1RBrTLdkYt3aDoOxO4Fw'
};
